<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="Category"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/Category/CoreCategoryDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreCategoryDetail from "@/components/CoreComponent/Category/CoreCategoryDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "CoreCategoryTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'CategoryTable'},
    dtoDetailQuery: {default: 'CategoryDetailQueryDTO'},
    detailStoreName: {default: 'CategoryDetail'},
    dtoValidateCommand: {type: [String], default: 'CategoryValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'CategoryListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CategoryActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreCategoryDetail,
    BaseFieldCheck,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Category', value: 'category', sortable: true, filterable: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['category']
      this.storeTable.options.sortDesc = [true]
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>